import { render } from "./CLOChatsPage.vue?vue&type=template&id=1d404bf5"
import script from "./CLOChatsPage.vue?vue&type=script&lang=js"
export * from "./CLOChatsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__